import React from 'react';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import { PageContainer, Poppins } from 'src/common';
import Audit from 'src/components/Audit';
import { useAuth } from 'src/state/auth';
import { TableIds } from 'src/api/types/misc';

const WorkspaceAuditPage = () => {
  const { profile } = useAuth();
  useGaEventPageView('Cydea | Workspace | Audit');

  return (
    <>
      <Meta title={`Cydea | Workspace | Audit`} feedbackScript />
      <PageContainer>
        <Poppins px={32} weight={600}>
          Audit Log
        </Poppins>

        <Audit
          noHide
          maxHeight={'calc(100vh - 86px)'}
          rootPath="workspaces"
          initQuery={{ workspace_id: profile?.activeWorkspace?.id }}
          initialShowAudit={true}
          tableId={TableIds.auditWorkspace}
        />
      </PageContainer>
    </>
  );
};

export default WorkspaceAuditPage;
